// extracted by mini-css-extract-plugin
module.exports = {"navigation":"BlogNavigation-module--navigation--3i1Lt","link":"BlogNavigation-module--link--M-7Dy","activeLink":"BlogNavigation-module--activeLink--2VpIU"};